import { IEventBus } from '../../interfaces/events/IEventBus';
import { SessionEvent, SessionEventType } from '../../interfaces/events/SessionEventTypes';

export class EventBus implements IEventBus {
  private listeners = new Map<SessionEventType | string, Set<(event: SessionEvent) => void>>();
  private anyListeners = new Set<(event: SessionEvent) => void>();

  emit(event: SessionEvent): void {
    // Emit to specific listeners
    const typeListeners = this.listeners.get(event.type);
    if (typeListeners) {
      typeListeners.forEach(callback => {
        try {
          callback(event);
        } catch (error) {
          console.error('Error in event listener:', error);
        }
      });
    }

    // Emit to any listeners
    this.anyListeners.forEach(callback => {
      try {
        callback(event);
      } catch (error) {
        console.error('Error in any event listener:', error);
      }
    });
  }

  on(eventType: SessionEventType | string, callback: (event: SessionEvent) => void): void {
    if (!this.listeners.has(eventType)) {
      this.listeners.set(eventType, new Set());
    }
    this.listeners.get(eventType)!.add(callback);
  }

  off(eventType: SessionEventType | string, callback: (event: SessionEvent) => void): void {
    const typeListeners = this.listeners.get(eventType);
    if (typeListeners) {
      typeListeners.delete(callback);
    }
  }

  onAny(callback: (event: SessionEvent) => void): void {
    this.anyListeners.add(callback);
  }

  offAny?(callback: (event: SessionEvent) => void): void {
    this.anyListeners.delete(callback);
  }
}
